export enum EditorType {
  Compose,
  Kubernetes,
  Nomad,
}
